import { TimestampFormat, formatTimestamp } from "./timestampFormat";

/**
 * Renders an anchor candidate's absolute instant for the settings UI — always
 * local date and time, whatever format the user reads timestamps in.
 *
 * A calendar date is what a person can check at a glance ("is this the run I
 * mean?"), and what exposes a pasted epoch-seconds value as 1970 before it is
 * committed. The user's own format is unusable here: it may be Relative, which
 * is circular for the anchor itself, and the absolute format it falls back to
 * is not exposed by the context once an anchor exists.
 *
 * The decimal-places setting is not threaded through either, for the same
 * reason: this is a control's readout, not a timestamp in the transcript. It
 * renders at the shared millisecond default, wide enough to identify an
 * instant and narrow enough to fit a picker row.
 */
export function formatAnchorTime(ns: bigint): string {
  return formatTimestamp(ns, TimestampFormat.LocalTime);
}
